import { Button, Modal } from "antd";
import React from "react";

interface ConsumptionDataReuploadModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConsumptionDataReuploadModal: React.FC<ConsumptionDataReuploadModalProps> = ({ visible, onClose, onConfirm }) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      title="Reupload Consumption File"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="confirm" type="primary" onClick={handleConfirm}>
          Confirm
        </Button>,
      ]}
      width={400}
    >
      <p>
        This action will delete the current consumption record. After uploading the new consumption file, these changes
        will be irreversible. Are you sure you want to proceed?
      </p>
    </Modal>
  );
};

export default ConsumptionDataReuploadModal;
